<template>
	<div class="myNav">
		<div class="title">
			<img src="@/assets/nav_logo.png" alt="" />
			<span>慧年健康科技（重庆）有限公司</span>
			<div class="nav">
				<router-link
					v-for="(nav, index) in navList"
					:key="index"
					:to="nav.toPath"
					:class="['nav-item', current === index ? 'active' : '']"
					@click.native="doChooes(index)"
					>{{ nav.name }}</router-link
				>
				<!-- <router-link to="/about" class="nav-item" @click.native="doChooes(1)">下载中心</router-link> -->
			</div>
		</div>
	</div>
</template>

<script>
export default {
	// 菜单
	name: 'myNav',
	data() {
		return {
			current: 0,
			navList: [
				{ toPath: '/', name: '首页' },
				{ toPath: '/down', name: '下载中心' },
			],
		}
	},
	methods: {
		doChooes(index) {
			this.current = index
		},
	},
}
</script>

<style lang="scss" scoped>
.myNav {
	width: 100%;
	height: 80px;
	background: #fff;
	font-size: 18px;
	font-weight: 500;
	color: #333333;
	.title {
		height: 100%;
		display: flex;
		align-items: center;
		img {
			margin-left: 17%;
		}
		span {
			margin-left: 15px;
		}
	}
	.nav {
		display: flex;
		height: 100%;
		align-items: center;
		justify-content: center;
		margin-left: 13%;
		a {
			text-decoration: none;
			color: #333;
		}
		a:-webkit-any-link:active {
			color: #333;
		}
		&-item {
			padding: 0 27px;
			height: 100%;
			line-height: 80px;
		}
		.active {
			background: #2dae36;
			color: #fff;
		}
	}
}
</style>
